import { parentFind } from "library/tree/index.mjs"

export function getPredicate(c) {
    return c.id === "schedules" || parentFind(c, (c) => c.label === "Schedule Library")
}
